export default __webpack_public_path__ + "static/media/rtr-200-fi-moto.e09701b4.png";